import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, applyConsentMode } from "@/lib/events";

/** Consent banner — Google Consent Mode v2 defaults (denied) + granular choices.
 * Nothing non-essential fires before this is answered. */
export default function ConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c) applyConsentMode(c);
    else {
      applyConsentMode(null);
      setShow(true);
    }
  }, []);

  if (!show) return null;

  const choose = (c) => {
    setConsent(c);
    setShow(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-white border-t border-stone-200 shadow-lg" data-testid="consent-banner">
      <div className="container-x py-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <p className="text-xs text-stone-600 flex-1 leading-relaxed">
          We use cookies for analytics and, only with your permission, to understand what you'd love to see more of.
          Prices, cart and checkout work either way. Read our <Link to="/policies" className="underline text-brand">policies</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => choose({ analytics: false, marketing: false })}
            className="px-4 py-2 border border-stone-300 rounded-full text-xs hover:border-stone-500 transition-colors" data-testid="consent-essential">
            Essential only
          </button>
          <button onClick={() => choose({ analytics: true, marketing: false })}
            className="px-4 py-2 border border-stone-300 rounded-full text-xs hover:border-stone-500 transition-colors" data-testid="consent-analytics">
            Analytics
          </button>
          <button onClick={() => choose({ analytics: true, marketing: true })}
            className="px-4 py-2 bg-brand text-ivory rounded-full text-xs font-medium btn-press" data-testid="consent-all">
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
